import { useState, useEffect } from "react";
import { Button } from "@mui/material";
import {
  Switch,
  FormControlLabel,
  TextField,
  Grid,
  CardActions,
  CardContent,
  CardHeader,
  Card,
  Loading,
} from "../../../components";
import { FamiliaProdutosService, notification } from "../../../services";
import { InputErros, PermisoesHelper } from "../../../helpers";
import { responseErros } from "../../../utils";
import familiaProdutosValidator from "./middlewares/familiaProdutos.validator";
import { FamiliaProdutoEntity } from "../entities";

const AddFamiliaProdutos = ({
  id,
  handleCloseDialog,
  buscaFamiliasProdutos,
}) => {
  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("grupo-produtos-visualizar");
  const [loading, setLoading] = useState(false);
  const [familiaProdutos, setFamiliaProdutos] = useState({ ativado: true });
  const [inputErro, setInputErro] = useState([]);
  const inputErros = new InputErros(inputErro, setInputErro);
  const familiaProdutosService = new FamiliaProdutosService();

  useEffect(() => {
    if (id) {
      buscarFamiliaProdutos();
    }
  }, []);

  const buscarFamiliaProdutos = async () => {
    setLoading(true);
    const result = await familiaProdutosService.getById(id);
    if (!result.isAxiosError) {
      setFamiliaProdutos(result.data);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  const handleInputChange = (event) => {
    setFamiliaProdutos((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    familiaProdutosValidator
      .validate(familiaProdutos, { abortEarly: false })
      .then(async () => {
        const familiaProdutoEntity = new FamiliaProdutoEntity(familiaProdutos);
        if (id) {
          const response = await familiaProdutosService.atualizar(
            id,
            familiaProdutoEntity
          );
          setLoading(false);
          if (!response.isAxiosError) {
            handleCloseDialog();
            notification.alteracaoSucesso();
            buscaFamiliasProdutos();
          } else {
            responseErros(response);
          }
        } else {
          const response = await familiaProdutosService.cadastrar(
            familiaProdutoEntity
          );
          setLoading(false);
          if (!response.isAxiosError) {
            handleCloseDialog();
            notification.cadastroSucesso();
            buscaFamiliasProdutos();
          } else {
            responseErros(response);
          }
        }
      })
      .catch((err) => {
        setLoading(false);
        inputErros.set(err);
      });
  };

  const handleCancelar = () => {
    setFamiliaProdutos(null);
    handleCloseDialog();
  };

  return (
    <>
      <Card className="p-3">
        <CardHeader
          title={
            id ? "Editar Família de Produtos" : "Cadastrar Família de Produtos"
          }
          action={
            <FormControlLabel
              control={
                <Switch
                  checked={
                    familiaProdutos?.ativado ? familiaProdutos?.ativado : false
                  }
                  onChange={() =>
                    setFamiliaProdutos((prevState) => ({
                      ...prevState,
                      ativado: !prevState?.ativado,
                    }))
                  }
                  name="ativado"
                  color="primary"
                />
              }
              label={familiaProdutos?.ativado ? "Ativado" : "Desativado"}
            />
          }
        />
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                id="descricao"
                name="descricao"
                label="Descrição"
                variant="outlined"
                value={
                  familiaProdutos?.descricao ? familiaProdutos.descricao : ""
                }
                onChange={(event) => {
                  setInputErro([]);
                  handleInputChange(event);
                }}
                fullWidth
                required
                error={inputErros.get("descricao")}
              />
            </Grid>
          </Grid>
        </CardContent>
        <CardActions>
          <Button
            color="primary"
            variant="contained"
            disabled={!permissoesHelper.temPermisao("grupo-produtos-cadastrar")}
            onClick={handleSubmit}
          >
            <i
              className="ph-fill ph-check-circle"
              style={{ fontSize: 22, marginRight: 10 }}
            ></i>
            Salvar
          </Button>
          <Button color="padrao" variant="contained" onClick={handleCancelar}>
            <i
              className="ph-fill ph-x-circle"
              style={{ fontSize: 22, marginRight: 10 }}
            ></i>
            Fechar
          </Button>
        </CardActions>
      </Card>
      <Loading loading={loading} />
    </>
  );
};

export default AddFamiliaProdutos;
